import React, { useMemo, useCallback, useEffect, useState, useRef } from 'react';
import { useLoaderData, useNavigate, Link } from 'react-router-dom';
import AxiosInstance from 'src/components/Axios';
import {
  CForm,
  CFormLabel,
  CFormInput,
  CButton,
  CRow,
  CCol,
  CCard,
  CCardHeader,
  CCardBody,
} from '@coreui/react';
import { DataGrid } from '@mui/x-data-grid';
import UsersCreateForm from './UsersCreateForm';
import { toast, ToastContainer } from 'react-toastify';
import Select from 'react-select';
import Card from 'react-bootstrap/Card';
import PermissionsNoPage, { Permissions } from 'src/components/Permissions';
import UsersNotificationsModal from '../user-notifications/UsersNotificationsModal';
import { formatNotificationDate, formatNotificationDateSend } from 'src/utils/notificationDates';

const urlApi = '/users';
const accountsApi = '/app_personal_accounts';
const notificationsApi = '/notifications';
const NOTIFICATIONS_ITEMS_PER_PAGE = 10;


export async function LoaderUsersUpdate({ params }) {
  if (Object.keys(params).length != 0) {
    let res = await AxiosInstance.get(`${urlApi}/${params.pid}`).then((response) => {
      return response;
    });
    return res;
  }
  return false;
}

const urlRouter = '/users';
const role = localStorage.getItem('user_role');
const userData = JSON.parse(localStorage.getItem('user_data'));

const staticRoles = [
  { label: 'APP_USER', value: 'APP_USER' },
  { label: 'ROLE_SITE', value: 'ROLE_SITE' },
  // { label: 'ROLE_ADMIN', value: 'ROLE_ADMIN' },
];

const UsersForm = ({ user_data }) => {
  // user_data prop може бути null, якщо routes.js завантажився до логіну
  // (читає localStorage на рівні модуля). Fallback: перевіряємо role напряму.
  const userRoleLocal = localStorage.getItem('user_role');

  // if (!Permissions(user_data, 'User', 'EDIT_USER') && userRoleLocal !== 'ROLE_ADMIN') {
  //   return <PermissionsNoPage />;
  // }
  const navigate = useNavigate();
  const { data } = useLoaderData();
  const [accountsRows, setAccountsRows] = useState([]);
  const [accountsCount, setAccountsCount] = useState(0);
  const [accountsLoading, setAccountsLoading] = useState(false);
  const [notificationsRows, setNotificationsRows] = useState([]);
  const [notificationsCount, setNotificationsCount] = useState(0);
  const [notificationsLoading, setNotificationsLoading] = useState(false);
  // DataGrid використовує 0-індексацію сторінок, API — 1-індексацію (page + 1 при запиті)
  const [notificationsPage, setNotificationsPage] = useState(0);
  const notificationsRequestIdRef = useRef(0);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalNotificationId, setModalNotificationId] = useState(null);
  const [modalNotificationData, setModalNotificationData] = useState(null);

  const [isEdit, setIsEdit] = useState(false);//для редагування полів

  //стани для відображення
  const [username, setUsername] = useState(data?.username || '');
  const [firstName, setFirstName] = useState(data?.firstName || '');
  const [lastName, setLasttName] = useState(data?.lastName || '');

  const [email, setEmail] = useState(data?.email || '');
  const [phone, setPhone] = useState(data?.phone || '');
  const [password, setPassword] = useState('');

  const [myData, setMyData] = useState(data ? data : false);

  //стани для ролей
  // const [roleList] = useState(staticRoles);
  const [roleList, setRoleList] = useState([]); // Список ролей, які існують в адмінці
  const [userRolesList, setUserRolesList] = useState([]);// Список ролей, які додані до користувача
  const [isDisabledRole, setIsDisableRole] = useState(false);


  const handleBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);


  // Функція для запиту за списком ролей
  const getRoleList = async () => {
    // TODO [LOCAL]: на локальному API немає endpoint /roles — запит закоментовано.
    // На проді розкоментувати тіло функції і прибрати setRoleList([]) / return [] нижче.
    // let rez = await AxiosInstance.get(`/roles`, { headers: { 'accept': 'application/json' } }).then((response) => {
    //   return response.data.map((result) => ({
    //     label: `${result.label} - ${result.name}`,
    //     value: result.id,
    //   }));
    // });
    // setRoleList(rez);
    // return rez;
    setRoleList([]);
    return [];
  };



  useEffect(() => {
    getRoleList();
    if (data != undefined) {
      let r = (data.userRoles ?? []).map((result) => ({
        label: `${result.role?.label} - ${result.role?.name}`,
        value: result.role?.id,
      }));
      setUserRolesList(r)
    }
    // if (role == 'ROLE_MANAGER')
    //   setRoleList([{ value: 'ROLE_CLIENT', label: 'Клієнт' }])
  }, []);



  const fields = useMemo(() => {
    // if (!data) return []; 
    if (!myData) return [];





    const formatValue = (value) => {
      if (value === null || value === undefined || value === '') return '';
      if (Array.isArray(value)) return value.join(', ');
      return String(value);
    };

    return [
      { key: 'id', label: 'ID', value: formatValue(myData?.id) },
      { key: 'username', label: 'Логін', value: formatValue(myData?.username) },
      { key: 'roles', label: 'Ролі', value: formatValue(myData?.roles) },
      //тут добавив замість просто ПІБ ,окремо поле для імені і окремо для фаміліі
      // { key: 'firstName', label: "ПІБ", value: formatValue(data?.firstName) },
      { key: 'firstName', label: "Ім'я", value: formatValue(myData?.firstName) },
      { key: 'lastName', label: "Фамілія", value: formatValue(myData?.lastName) },
      { key: 'phone', label: 'Телефон', value: formatValue(myData?.phone) },
      { key: 'email', label: 'Email', value: formatValue(myData?.email) },
      { key: 'status', label: 'Статус', value: formatValue(myData?.status) },
    ];
  }, [
    // data
    myData
  ]);

  useEffect(() => {
    // if (!data?.id) return;
    if (!myData?.id) return;

    setAccountsLoading(true);
    AxiosInstance
      .get(`${accountsApi}?owner.id=${myData?.id}`)
      .then((response) => {
        setAccountsRows(response.data?.['hydra:member'] || []);
        setAccountsCount(response.data?.['hydra:totalItems'] || 0);
      })
      .finally(() => setAccountsLoading(false));
  }, [
    // data?.id
    myData?.id
  ]);

  const getNotificationsRows = useCallback((page = 1) => {
    const requestId = ++notificationsRequestIdRef.current;
    setNotificationsLoading(true);
    AxiosInstance
      .get(`${notificationsApi}?users.id=${myData?.id}&page=${page}&itemsPerPage=${NOTIFICATIONS_ITEMS_PER_PAGE}`)
      .then((response) => {
        if (requestId !== notificationsRequestIdRef.current) return;
        setNotificationsRows(response.data?.['hydra:member'] || []);
        setNotificationsCount(response.data?.['hydra:totalItems'] || 0);
      })
      .finally(() => {
        if (requestId !== notificationsRequestIdRef.current) return;
        setNotificationsLoading(false);
      });
  }, [myData?.id]);

  const handleNotificationsPageChange = (page) => {
    setNotificationsPage(page);
    getNotificationsRows(page + 1);
  };

  useEffect(() => {
    if (!myData?.id) return;
    setNotificationsPage(0);
    getNotificationsRows(1);
  }, [
    myData?.id
  ]);

  //ініціалізація userRoleList userRolesList из myData.roles(поки закоментував)
  // useEffect(() => {
  //   if (!myData) return;
  //   const rolesForSelect = myData.roles?.map((r) => {
  //     return roleList.find(role => role.label === r) || { label: r, value: r };
  //   }) || [];
  //   setUserRolesList(rolesForSelect);
  // }, [myData, roleList]);



  const accountColumns = useMemo(() => ([
    { field: 'id', headerName: 'ID', width: 80 },
    {
      field: 'owner',
      headerName: 'Користувач (телефон)',
      width: 180,
      valueGetter: (params) => params.row.owner?.phone || '',
    },
    {
      field: 'pib',
      headerName: 'ПІБ',
      width: 220,
      valueGetter: (params) => params.row.owner?.firstName || '',
    },
    { field: 'number', headerName: 'Номер', width: 120 },
    {
      field: 'name',
      headerName: 'Назва',
      width: 180,
      renderCell: (params) => (
        <Link
          to={`/accounts/view/${params.row.id}`}
          style={{ textDecoration: 'none', color: 'rgba(0, 0, 0, 0.87)' }}
        >
          {params.row.name}
        </Link>
      ),
    },
    { field: 'type', headerName: 'Тип', width: 120 },
    { field: 'fullAddress', headerName: 'Адреса', width: 260 },
  ]), []);

  const notificationColumns = useMemo(() => ([
    { field: 'id', headerName: 'ID', width: 100 },
    {
      field: 'username',
      headerName: 'Логін',
      width: 150,
      // renderCell: (params) => (
      //   <Link
      //     to={`/users/view/${params.row.users?.id}`}
      //     style={{ textDecoration: 'none', color: 'rgba(0, 0, 0, 0.87)' }}
      //   >
      //     {params.row.users?.username || ''}
      //   </Link>
      // ),
      renderCell: (params) => params.row.users?.username || '',
    },
    {
      field: 'firstName',
      headerName: "Ім'я",
      width: 200,
      // renderCell: (params) => (
      //   <Link
      //     to={`/users/view/${params.row.users?.id}`}
      //     style={{ textDecoration: 'none', color: 'rgba(0, 0, 0, 0.87)' }}
      //   >
      //     {params.row.users?.firstName || ''}
      //   </Link>
      // ),
      renderCell: (params) => params.row.users?.firstName || '',
    },
    { field: 'title', headerName: 'Назва', width: 220 },
    { field: 'status', headerName: 'Статус', width: 90 },
    { field: 'error', headerName: 'Помилка', width: 200 },
    {
      field: 'dateEntered',
      headerName: 'Дата створення',
      width: 135,
      renderCell: (params) => formatNotificationDate(params.row.dateEntered),
    },
    {
      field: 'dateSend',
      headerName: 'Дата відправки',
      width: 135,
      // TODO [API]: dateSend на бекенді приходить без коректного зсуву офсету — див. примітку в src/utils/notificationDates.js
      renderCell: (params) => formatNotificationDateSend(params.row.dateSend),
    },
    {
      field: 'action_modal',
      headerName: '👁',
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      width: 60,
      renderCell: (params) => (
        <button
          className="custom-view-icon"
          title="Швидкий перегляд"
          onClick={() => {
            setModalNotificationData(params.row);
            setModalNotificationId(params.row.id);
            setModalOpen(true);
          }}
          style={{ background: 'none', cursor: 'pointer' }}
        >
          👁
        </button>
      ),
    },
  ]), []);

  //закінчив тут
  //пейлоад для апдейту
  const prepareUpdatePayload = () => {
    const payload = {};

    if (username !== myData?.username) {
      payload.username = username;
    }

    if (firstName !== myData?.firstName) {
      payload.firstName = firstName;
    }
    if (lastName !== myData?.lastName) {
      payload.lastName = lastName;
    }

    // if (phone !== myData?.phone) {
    //   payload.phone = phone;
    // }
    if (phone !== (myData?.phone ?? '')) {
      payload.phone = phone;
    }

    if (email !== myData?.email) {
      payload.email = email;
    }

    if (password && password !== '') {
      payload.plainPassword = password;
    }
    // if (userRolesList.length > 0) {
    //   payload.roles = userRolesList.map(r => r.label);
    // }
    //закоментував
    // payload.roles = userRolesList.length ? userRolesList.map(r => r.label) : [];

    // if (rolesChanged()) {
    //   payload.roles = userRolesList.map(r => r.label || r.value);
    // }

    return payload;
  };

  // Функція перевірки, чи змінилися ролі
  const rolesChanged = () => {
    if (!myData?.userRoles) return userRolesList.length > 0;

    // Беремо id ролей з myData
    const originalRoleIds = myData.userRoles.map(r => r.role.id);

    // Беремо id ролей, що зараз вибрані
    const currentRoleIds = userRolesList.map(r => r.value);

    // Порівнюємо довжину
    if (originalRoleIds.length !== currentRoleIds.length) return true;

    // Перевіряємо, чи всі id співпадають
    return !originalRoleIds.every(id => currentRoleIds.includes(id));
  };


  // Функція для видалення user_roles
  const deleteUserRole = async (id) => {
    try {
      const response = await AxiosInstance.delete(`/user_roles/${id}`);
    } catch (error) {
      console.error("Помилка видалення user_roles", error);
    };
  };

  // Функція для створення user_roles
  const createUserRole = async (id, userData) => {
    try {
      const response = await AxiosInstance.post(`/user_roles`, {
        users: `/api/users/${userData.id}`,
        role: `/api/roles/${id}`,
      });
    } catch (error) {
      console.error("Помилка створення user_roles", error);
    };
  };


  // Функція для створення/видалення user_roles
  const putUserRoles = async (userData) => {
    // Відслідковувати роль менеджера, щоб сам собі не зміг змінювати
    let rolesToCreate = []; // Список ролей, які потрібно додати до користувача
    let rolesToDelete = []; // Список ролей, які потрібно видалити від користувача
    console.log('putUserRole_userData')
    if (myData) {
      rolesToCreate = userRolesList.filter(userRole =>
        !myData.userRoles.some(role => role.role.id === userRole.value)
      );

      rolesToDelete = myData.userRoles.filter(userRole =>
        !userRolesList.some(role => role.value === userRole.role.id)
      );
    } else {
      rolesToCreate = userRolesList;
    };

    // Обробка додавання ролей
    for (const role of rolesToCreate) {
      await createUserRole(role.value, userData);
    };

    // Обробка видалення ролей
    for (const role of rolesToDelete) {
      await deleteUserRole(role.id);
    };
  };




  // Функція для оновлення user
  const updateUser = async (payload) => {
    try {
      // const payload = prepareUpdatePayload();


      // const response = await AxiosInstance.put(`${urlApi}/${myDataId(myData)}`, data_response);
      if (Object.keys(payload).length > 0) {
        const response = await AxiosInstance.put(`${urlApi}/${myDataId(myData)}`, payload);
        setPassword('');
        // toast.success('Дані користувача оновлено!');
      }


      // Оновити ролі
      // await putUserRoles(
      //   myData
      //   // response.data
      // );
      if (rolesChanged()) {
        await putUserRoles(myData);
      }

      // Поставив затримку, оскільки не встигали оновлюватися дані по user_roles на сервері і повертало старі дані
      // setTimeout(() => {
      await getUserData();
      // }, 300);
      // popup.toastifySuccess('Користувача оновлено!');
      // setMyData(response.data)
      setPassword('')
      toast.success('Користувача оновлено!');
    } catch (error) {
      // popup.toastifyWarning('Помилка оновлення користувача'); 
      toast.error('Помилка оновлення користувача');
      console.error("Помилка оновлення користувача", error);
    };
  };

  // Функція для запиту за даними користувача
  const getUserData = async () => {
    try {
      const response = await AxiosInstance.get(`${urlApi}/${myDataId(myData)}`);
      setMyData(response.data);
    } catch (error) {
      console.error("Помилка запиту за даними користувача", error);
    };
  };

  function myDataId(row) {
    if (row.id) return row.id;
    if (row['@id']) return row['@id'].split('/').pop();
  }

  //апдейт майдати
  useEffect(() => {
    if (!myData) return;

    setUsername(myData.username || '');
    setFirstName(myData.firstName || '');
    setLasttName(myData.lastName || '');
    setEmail(myData.email || '');
    setPhone(myData.phone || '');
  }, [myData]);


  // if (!data) 
  if (!myData) {
    return (
      // <CForm className="mb-3">
      //   <p className="text-medium-emphasis mb-3">Дані користувача відсутні.</p>
      //   <CButton color="secondary" variant="outline" onClick={handleBack}>
      //     Повернутись
      //   </CButton>
      // </CForm>
      <>
        <CForm className="mb-3">
          <p className="text-medium-emphasis mb-3">Дані користувача відсутні. Можна створити нового користувача.</p>
        </CForm>
        {/* форма створення */}
        <UsersCreateForm
          roleList={roleList}
          setRoleList={setRoleList}
          userRolesList={userRolesList}
          setUserRolesList={setUserRolesList}
          putUserRoles={putUserRoles}
          // myData={null}
          setMyData={setMyData}
          getUserData={getUserData}
        />
      </>
    );
  }


  return (
    <>
      <ToastContainer />
      <CForm className="mb-3">
        {isEdit && role === 'ROLE_ADMIN' ?
          // <CRow className="g-3">
          //   {fields.map(({ key, label, value }) => (
          //     <CCol md={6} key={key}>
          //       <CFormLabel>{label}</CFormLabel>
          //       <CFormInput type="text" value={value} disabled readOnly />
          //     </CCol>
          //   ))}
          // </CRow>
          //  :
          (
            <CRow className="g-3">

              <CCol md={6}>
                <CFormLabel>Логін</CFormLabel>
                <CFormInput
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </CCol>

              <CCol md={6}>
                <CFormLabel>Пароль</CFormLabel>
                <CFormInput
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </CCol>

              <CCol md={6}>
                <CFormLabel>Email</CFormLabel>
                <CFormInput
                  value={email}
                  // onChange={(e) => setEmail(e.target.value)}
                  onChange={(e) => {
                    const val = e.target.value;
                    // дозволяєм тілько букви, цифры, @, ., _, -
                    if (/^[a-zA-Z0-9@._-]*$/.test(val)) {
                      setEmail(val);
                    }
                  }}
                />
              </CCol>

              {/* <CCol md={6}>
                <CFormLabel>ПІБ</CFormLabel>
                <CFormInput
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </CCol> */}
              {/*Замість поля ПІБ добавляю два поля firstName i lastName  */}
              <CCol md={6}>
                <CFormLabel>Ім'я</CFormLabel>
                <CFormInput
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </CCol>
              <CCol md={6}>
                <CFormLabel>Прізвище</CFormLabel>
                <CFormInput
                  value={lastName}
                  onChange={(e) => setLasttName(e.target.value)}
                />
              </CCol>
              {/* телефон закоментовано */}
              <CCol md={6}>
                <CFormLabel>Телефон</CFormLabel>
                <CFormInput
                  value={phone}
                  onChange={(e) => {
                    let val = e.target.value;

                    // дозволяєм  тілько + на початку і цифри після
                    if (/^\+?[\d]*$/.test(val)) {
                      // якщо початок не +380, автоматично ставимо
                      if (!val.startsWith('+380')) {
                        val = '+380' + val.replace(/\D/g, '').slice(0, 9); // залишаєм тільки 9 цифр після +380
                      } else {
                        // дозволяєм максимум 13 символів (+380 + 9 цифр)
                        val = '+380' + val.slice(4).replace(/\D/g, '').slice(0, 9);
                      }
                      setPhone(val);
                    }
                  }}
                />
              </CCol>

              {/* редагування ролей */}
              {isEdit && role === 'ROLE_ADMIN' && (
                <CCol md={6}>
                  <CFormLabel>Ролі користувача</CFormLabel>
                  <Select
                    value={userRolesList}
                    isMulti
                    options={roleList}
                    // onChange={(selected) => {
                    //   const hasAppUser = selected.some((r) => r.label === 'APP_USER');
                    //   const hasRoleSite = selected.some((r) => r.label === 'ROLE_SITE');
                    //   if (hasAppUser && hasRoleSite) {
                    //     const lastSelected = selected[selected.length - 1];
                    //     setUserRolesList([lastSelected]);
                    //   } else {
                    //     setUserRolesList(selected);
                    //   }
                    // }}
                    onChange={(selected) => setUserRolesList(selected)}
                    isDisabled={isDisabledRole}
                  />
                </CCol>
              )}

            </CRow>
          )
          : <CRow className="g-3">
            {fields.map(({ key, label, value }) => (
              <CCol md={6} key={key}>
                <CFormLabel>{label}</CFormLabel>
                <CFormInput type="text" value={value} disabled readOnly />
              </CCol>
            ))}
          </CRow>


        }
        <div>

        </div>
        <div className="d-flex justify-content-start mt-4">
          <CButton color="secondary" variant="outline" onClick={handleBack}>
            Повернутись
          </CButton>
          {!isEdit && <CButton
            color="success"
            className="ms-2"
            onClick={() => setIsEdit(true)}
          >
            Редагувати
          </CButton>}
          {isEdit && <CButton
            color="success"
            className="ms-2"
            onClick={() => {
              const payload = prepareUpdatePayload();

              // console.log('payload', payload);
              // console.log('Object.keys(payload)', Object.keys(payload))
              // console.log('myDataId', myDataId(myData))
              if (Object.keys(payload).length === 0 && !rolesChanged()) {
                toast.info('Немає змін');
                return;
              }

              updateUser(payload);
              setIsEdit(false);
            }}

          >
            Зберегти
          </CButton>}
          {isEdit && <CButton
            color="danger"
            className="ms-2"
            onClick={() => setIsEdit(false)}
          >
            Відмінити
          </CButton>}
        </div>
      </CForm>

      {/* блок перенесено з адмінки сайту(відображення ролі і меню ,якщо є) */}
      {
        myData &&
        <Card>
          <Card.Header>Доступи</Card.Header>
          <Card.Body>
            <table className='table'>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Роль</th>
                  <th>Меню</th>
                </tr>
              </thead>
              <tbody>
                {(myData.userRoles ?? []).map((user_role, index) => {
                  return (
                    <tr key={user_role.id}>
                      <td>{index + 1}</td>
                      <td><Link to={`/roles/view/${user_role.role?.id}`} target='_blank'><strong>{user_role.role?.label}</strong> - {user_role.role?.name}</Link></td>
                      <td>
                        {(user_role.role?.menus != undefined) &&
                          user_role.role.menus.map((menu) => {
                            return (
                              <Link to={`/menu/update/${menu.id}`} target='_blank' key={menu.id}>{menu.name}</Link>
                            )
                          })
                        }
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </Card.Body>
        </Card>
      }

      {accountsRows.length > 0 && (
        <CCard className="mb-4">
          <CCardHeader>
            <strong>Особові рахунки користувача</strong>
          </CCardHeader>
          <CCardBody>
            <div style={{ height: 400, width: '100%' }}>
              <DataGrid
                rows={accountsRows}
                columns={accountColumns}
                pageSize={10}
                rowsPerPageOptions={[10]}
                loading={accountsLoading}
                rowCount={accountsCount}
                disableSelectionOnClick
              />
            </div>
          </CCardBody>
        </CCard>
      )}

      {notificationsRows.length > 0 && (
        <CCard>
          <CCardHeader>
            <strong>Сповіщення користувача</strong>
          </CCardHeader>
          <CCardBody>
            <div style={{ height: 400, width: '100%' }}>
              <DataGrid
                rows={notificationsRows}
                columns={notificationColumns}
                pageSize={NOTIFICATIONS_ITEMS_PER_PAGE}
                rowsPerPageOptions={[NOTIFICATIONS_ITEMS_PER_PAGE]}
                loading={notificationsLoading}
                rowCount={notificationsCount}
                paginationMode="server"
                page={notificationsPage}
                onPageChange={handleNotificationsPageChange}
                disableSelectionOnClick
              />
            </div>
          </CCardBody>
        </CCard>
      )}

      <UsersNotificationsModal
        open={modalOpen}
        notificationId={modalNotificationId}
        initialData={modalNotificationData}
        onClose={() => setModalOpen(false)}
      />
    </>
  );
};

export default UsersForm;